import { i18n } from 'i18next';
import { useCallback } from 'react';
import { useTranslation as useIntl } from 'react-i18next';

import translationsJson from '../../public/locales/en/public.json';

type DeepKeysOf<T, Key extends keyof T = keyof T> = Key extends string
  ? T[Key] extends string
    ? Key
    : `${Key}.${DeepKeysOf<T[Key]>}`
  : never;

export type TranslationKey = DeepKeysOf<typeof translationsJson>;

export type TranslationsCallback = (key: TranslationKey, options?: Record<string, string> | undefined) => string;

export default function usePublicTranslation(): TranslationsCallback {
  const { t } = useIntl('public');
  return useCallback((key: TranslationKey, options?: Record<string, string>) => t(key, options), [t]);
}

export function usePublicTranslator(): i18n {
  const { i18n } = useIntl('public');
  return i18n;
}
